<script setup lang="ts">
import { Head, Link, router, useForm } from '@inertiajs/vue3'
import PageHeading from '@/Components/Headings/PageHeading.vue'
import { capitalize } from "@/Composables/capitalize"
import { computed, inject, onMounted, onUnmounted, ref, watch } from 'vue'

import { routeType } from '@/types/route'
import { PageHeading as PageHeadingTypes } from  '@/types/PageHeading'
import { Tabs as TSTabs } from '@/types/Tabs'
import '@vuepic/vue-datepicker/dist/main.css'

import '@/Composables/Icon/PalletDeliveryStateEnum'
import { notify } from '@kyvg/vue3-notification'

import Dialog from 'primevue/dialog'
import { faTimes, faUndoAlt, faExternalLink } from '@fal'
import { faDotCircle } from '@far'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faExclamationTriangle } from '@fad'
import { library } from "@fortawesome/fontawesome-svg-core"
library.add(faTimes, faUndoAlt, faExternalLink, faDotCircle, faExclamationTriangle)

import Stepper from 'primevue/stepper';
import StepList from 'primevue/steplist';
import Select from 'primevue/select'
import Step from 'primevue/step';
import Textarea from 'primevue/textarea'
import Divider from 'primevue/divider';
import { useFormatTime } from '@/Composables/useFormatTime'
import Button from '@/Components/Utils/Button.vue'
import Tag from '@/Components/Utils/Tag.vue'
import { Fieldset } from 'primevue'
import Icon from '@/Components/Utils/Icon.vue'
import { aikuLocaleStructure } from '@/Composables/useLocaleStructure'
import { useTruncate } from '@/Composables/useTruncate'
import { layoutStructure } from '@/Composables/useLayoutStructure'
import ModalConfirmationDelete from '@/Components/Utils/ModalConfirmationDelete.vue'
import IconManufacture from '@/Components/Utils/IconManufacture.vue'
import { Action } from '@/types/Action'
import PureTextarea from '@/Components/Pure/PureTextarea.vue'

const props = defineProps<{
    title: string
    tabs: TSTabs
    // pallets?: TableTS
    // services?: TableTS
    // physical_goods?: TableTS
    data?: {
        data: {}
    }
    root_active?: string // 'manufacture.not_started.'
    action?: Action
    timeline: {
        options: {
            key: string
            index: string
            label: string
            icon: string
            tooltip: string
            timestamp: string
            current: boolean
            class_current?: string
        }[]
        state: string
    }
    manufacture: {
        id: number
        quantity: number
        product?: {
            type_icon?: {
                tooltip?: string
                icon: string | string[]
                class?: string
            }
            name?: string
            category?: {
                name?: string
            }
            price?: number
            quantity?: number
        }
        order?: {
            reference?: string
            slug?: string
            note?: string
        }
        brand?: string
        source?: string
        product_name?: string
        cs_order?: {
            slug?: string
            reference?: string
            state_label?: string
            note?: string
            estimated_finished_at?: string
            customer?: string
        } | null
        cs_stock?: {
            id: number
            product_name: string
            is_general: boolean
            brand_name?: string | null
        } | null
        cs_order_product?: {
            name?: string
            variation_name?: string
            category_name?: string
            sku?: string
            manufacture_name?: string
            quantity?: number
            print_type_label?: string
            print_type_icon?: {
                tooltip?: string
                icon: string | string[]
                class?: string
            }
            note?: string
        } | null
        designs?: {
            id: number
            name: string
            link: string
            note?: string
            product_name?: string
            link_updated_at?: string
            is_for_this_product: boolean
        }[]
    }
    pageHead: PageHeadingTypes
    updateRoute: routeType

    // rental_lists?: [],
    // box_stats: BoxStats
    // notes_data: PDRNotes[]
    pallet_limits?: {
        status: string
        message: string
    }
    data_page: {
        product_type: string
    }
    errors: {
        [key: string]: string
    }
}>()


const locale = inject('locale', aikuLocaleStructure)
const layout = inject('layout', layoutStructure)



const activeStep = computed(() => {
    const indexCurrent = props.timeline.options.findIndex((option) => option.current)
    if (indexCurrent === -1) {
        return props.timeline.options.length + 1
    } else {
        return indexCurrent
    }
})


const isLoading = ref(false)
const selectedModal = ref<string | null>(null)
const countPlat = ref(1)
const praCetakNote = ref<string>('')
const validate_note = ref<string | null>(null)
const validated_count = ref<number | null>(null)
const submitSelesaikan = () => {
    if(props.action) {
        router[props.action.route.method || 'patch'](
            route(props.action.route.name, props.action.route.parameters),
            {
                pra_cetak_count_plat: countPlat.value,
                pra_cetak_note: praCetakNote.value,
                cetak_count: cetak_count.value,
                cetak_note: cetak_note.value,
                finishing_count: finishing_count.value || 0,
                finishing_broken_count: finishing_broken_count.value || 0,
                plastic_count: countPlastic.value || 0,
                piece_per_plastic_count: countPiecePerPlastic.value || 0,
                finishing_note: finishing_note.value,
                validated_note: validate_note.value,
                validated_count: validated_count.value,
            },
            {
                onStart: () => {
                    isLoading.value = true
                },
                onFinish: () => {
                    isLoading.value = false
                },
                onSuccess: () => {
                    selectedModal.value = null
                },
                onError: () => {
                    notify({
                        title: 'Percobaan gagal.',
                        text: 'Sepertinya ada masalah😢',
                        type: 'error',
                    })
                },
            }
        )
    }
}
const onClickSelesaikan = (straightSubmit?: boolean) => {
    if (straightSubmit) {
        submitSelesaikan()
    } else if (props.timeline.state === 'not_started') {
        selectedModal.value = 'pra_cetak'
    } else if (props.timeline.state === 'pra_cetak') {
        selectedModal.value = 'cetak'
    } else if (props.timeline.state === 'cetak') {
        selectedModal.value = 'finishing'
    } else if (props.timeline.state === 'finishing') {
        selectedModal.value = 'validate'
    } else {
        submitSelesaikan()
    }
}

// Section: Cetak
const cetak_count = ref(props.manufacture.quantity)
const cetak_note = ref('')

// Section: Finishing
const countPlastic = ref()
const countPiecePerPlastic = ref()
const finishing_note = ref('')
const finishing_count = ref()
const finishing_broken_count = ref()


const _timelineWrapper = ref(null)
onMounted(() => {
    if (_timelineWrapper.value) {
        _timelineWrapper.value.scrollLeft = (100 * activeStep.value) - 50
    }

    layout.root_active = props.root_active === 'manufacture.pra_cetak.' ? 'manufacture.pracetak.' : props.root_active
})

onUnmounted(() => {
    layout.root_active = ''
})

watch(activeStep, () => {
    if (_timelineWrapper.value) {
        _timelineWrapper.value.scrollLeft = (100 * activeStep.value) - 50
    }
}, { immediate: true })


const isFromKasir = computed(() => props.manufacture.source === 'kasir')

const canOpenKasirPages = computed(() => ['super_admin', 'sales_special'].includes(layout?.auth?.role))

const generateLinkKasirOrder = (slug?: string) => {
    if (!slug || !canOpenKasirPages.value) return null

    return route('kasir.orders.show', slug)
}

const generateLinkOrder = (order: { slug: string }) => {
    if (!order?.slug) return null
    switch (route().current()) {
        case 'manufacture.show':
            return route('master.orders-m.show', order.slug)
        case 'sales.manufactures.show':
            return route('sales.orders.show', order.slug)
        default:
            return null
    }
}


const generateLinkSales = (username?: string) => {
    if (!username) return null
    
    switch (layout?.auth?.role) {
        case 'super_admin':
        case 'admin':
            return route('master.sales-m.index.show', username)
        default:
            return null
    }
}

const generateLinkBrand = (slug?: string) => {
    if (!slug) return null

    if (isFromKasir.value) {
        return canOpenKasirPages.value ? route('kasir.brands.show', slug) : null
    }

    switch (layout?.auth?.role) {
        case 'sales_special':
        case 'sales':
            return route('sales.brands.show', slug)
        default:
            return null
    }
}

const generateLinkProduct = (slug?: string) => {
    if (!slug) return null
    
    switch (layout?.auth?.role) {
        case 'super_admin':
        case 'admin':
            return route('master.products.show', slug)
        default:
            return null
    }
}

// Section: Validate Customer
const count_validate_from_customer = ref<number | null>(null)
const count_validate_from_customer_note = ref('')
const isLoadingValidateCustomer = ref(false)
const submitValidateCustomer = () => {
    router.patch(
        route('manufacture.validate_by_customer', props.manufacture.id),
        {
            count_validate_from_customer: count_validate_from_customer.value,
            count_validate_from_customer_note: count_validate_from_customer_note.value,
        },
        {
            onStart: () => {
                isLoadingValidateCustomer.value = true
            },
            onFinish: () => {
                isLoadingValidateCustomer.value = false
            },
            onSuccess: () => {
                selectedModal.value = null
            },
            onError: () => {
                notify({
                    title: 'Oops! Gagal memvalidasi.',
                    text: 'Sepertinya ada masalah😢',
                    type: 'error',
                })
            },
        }
    )
}
</script>

<template>
    <Head :title="capitalize(title)" />
    <PageHeading :data="pageHead">
        <template #afterTitle>
            <Tag v-if="props.timeline.state === 'canceled'" label="Dicancel" :theme="7" noHoverColor size="base" />
            <Tag v-if="props.timeline.state === 'picked'" label="Selesai" :theme="3" noHoverColor size="base" />
        </template>

        
        <!-- Button: batal -->
        <template #button-batal-manufacture="{ action }">
            <div>
                <ModalConfirmationDelete
                    :routeDelete="action.route"
                    isFullLoading
                    title="Batalkan manufacture?"
                    description="Jika batal, order tidak akan ditagihkan"
                    yesLabel="Ya, batalkan manufacture"
                    yesIcon="fal fa-undo-alt"
                >
                    <template #default="{ isOpenModal, changeModel, isLoadingdelete }">
                        <Button
                            @click="() => changeModel()"
                            :style="action.style"
                            :label="action.label"
                            :loading="isLoadingdelete"
                            :icon="action.icon"
                            :iconRight="action.iconRight"
                            :key="`ActionButton${action.label}${action.style}`"
                            :tooltip="action.tooltip"
                        />
                    </template>
                </ModalConfirmationDelete>
            </div>
        </template>
    </PageHeading>

    <!-- Section: Pallet Warning -->
    <!-- <div v-if="pallet_limits" class="p-4">
        <div class="p-4 rounded-md"
            :class="{
                'bg-yellow-50': pallet_limits === 'almost',
                'bg-orange-200': pallet_limits === 'limit',
                'bg-red-200': pallet_limits === 'exceeded',
            }"
        >
            <div class="flex" :class="{
                'text-amber-500': pallet_limits === 'almost',
                'text-orange-600': pallet_limits === 'limit',
                'text-red-600': pallet_limits === 'exceeded',
            }">
                <div class="flex items-center">
                    <font-awesome-icon :icon="['fad', 'exclamation-triangle']" class="text-2xl"
                        aria-hidden="true"
                        fixed-width
                        
                    />
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium">Penanganan diperlukan</h3>
                    <div class="text-xs opacity-70 ">
                        <p>Manufacture telah berhenti selama 3 hari</p>
                    </div>
                </div>
            </div>
        </div>
    </div> -->


    <!-- Section: Box Note -->
    <!-- <div class="grid grid-cols-3 h-fit lg:max-h-64 w-full lg:justify-center border-b border-gray-300">
        <BoxNote v-for="(note, index) in notes_data" :key="index+note.label" :noteData="note"
            :updateRoute="updateRoute" />
    </div> -->
    
    <!-- Section: Timeline -->
    <div ref="_timelineWrapper" class="transition-all pl-6 pr-12 md:px-20 w-screen md:w-full overflow-x-auto overflow-y-clip">
        <Stepper class="basis-[40rem] py-10 w-min md:w-full mb-8">
            <StepList>
                <Step v-for="(option, idxOptions) in timeline.options" v-slot="{ activateCallback, value, a11yAttrs }" asChild :value="1" v-tooltip="option.tooltip">
                    <div class="flex flex-row gap-2 pl-12 md:pl-2" v-bind="a11yAttrs.root"
                        :class="idxOptions !== timeline?.options?.length-1 ? 'flex-auto' : ''"
                    >
                        <button v-tooltip="option.tooltip" class="cursor-auto relative bg-transparent border-0 inline-flex flex-col gap-2" @click="activateCallback" v-bind="a11yAttrs.header">
                            <span
                                class="rounded-full border-2 w-10 md:w-12 h-10 md:h-12 inline-flex items-center justify-center"
                                :class="[
                                    idxOptions == activeStep
                                        ? 'bg-sky-100 animate-pulse text-sky-600 border-sky-600'
                                        : idxOptions < activeStep
                                            ? option.timestamp
                                                ? option.class_current || 'bg-sky-600 text-white border-sky-200'
                                                : 'bg-gray-200 text-gray-400 border-gray-300'
                                            : 'text-gray-400',
                                ]"
                            >
                                <!-- <FontAwesomeIcon :icon='option.icon' class='' fixed-width aria-hidden='true' /> -->
                                <IconManufacture :data="{ icon: option.icon }" />
                            </span>

                            <!-- <div v-if="option.current" class="absolute bg-yellow-500 animate-ping rounded-full border-2 w-12 h-12" /> -->

                            <!-- Stock -->
                            <div v-if="typeof option.value === 'number'" class="absolute left-1/2 -translate-x-1/2 -top-6 flex flex-col justify-center">
                                <div v-tooltip="useFormatTime(option.timestamp, {formatTime: 'EEEE HH:mm, dd MMM yyyy'})" class="whitespace-nowrap text-gray-400 text-xs md:text-sm">
                                    {{ locale.number(option.value || 0) }} pcs
                                </div>
                            </div>

                            <!-- Name & Date -->
                            <div class="text-sm md:text-base absolute left-1/2 -translate-x-1/2 -bottom-11 -md:bottom-14 flex flex-col justify-center">
                                <div class="lg:hidden whitespace-nowrap font-medium md:font-semibold">{{ useTruncate(option.label, 9) || '-' }}</div>
                                <div class="hidden lg:block whitespace-nowrap font-medium md:font-semibold">{{ useTruncate(option.label, 20) || '-' }}</div>
                                <div v-tooltip="useFormatTime(option.timestamp, {formatTime: 'EEEE HH:mm, dd MMM yyyy'})" class="whitespace-nowrap text-gray-400 text-xs md:text-sm">{{ useFormatTime(option.timestamp) }}</div>
                            </div>
                        </button>

                        <Divider v-if="idxOptions !== timeline?.options?.length-1" />
                    </div>
                </Step>
            </StepList>
        </Stepper>
    </div>

    <!-- Section: Produk info -->
    <div class="px-4 lg:px-8 mt-5 md:mt-14 py-5 grid  lg:mx-auto lg:w-full gap-x-8 gap-y-6"
        :class="isFromKasir ? 'lg:max-w-7xl lg:grid-cols-3' : 'lg:max-w-5xl lg:grid-cols-2'"
    >
        
        <!-- Section: button -->
        <div class="row-start-1 md:row-auto flex justify-center items-center"
            :class="isFromKasir ? 'lg:col-span-3' : 'lg:col-span-2'"
        >
            <!-- Button: ambil barang, validasi, etc -->
            <div v-if="action?.key === 'picked'" class="mx-auto">
                <Button @click="() => onClickSelesaikan(true)" :label="action?.label" :loading="isLoading" size="2xl" />
            </div>
            <div v-else-if="action?.key === 'late_validate'" class="mx-auto">
                <Button @click="() => selectedModal = 'validate'" :icon="action.icon" :label="action?.label" :loading="isLoading" size="2xl" />
            </div>
            <div v-else-if="action" class="mx-auto">
                <Button @click="() => onClickSelesaikan()" :label="action?.label" :icon="action.icon" :loading="isLoading" size="2xl" />
            </div>

            <!-- Button: validasi customer -->
            <div v-if="
                manufacture.picked_at
                && (layout?.auth?.role == 'admin' || layout?.auth?.role == 'super_admin')
                && data_page?.product_type == 'custom'
                && !manufacture.count_validate_from_customer_setted_at
            " class="mx-auto">
                <Button @click="() => selectedModal = 'validate_customer'" type="tertiary" label="Validasi dari customer" icon="fal fa-user-check" :loading="isLoadingValidateCustomer" size="2xl" />
            </div>
        </div>

        <Fieldset legend="Detail Order" class="w-full lg:max-w-lg">
            <dl class="divide-y divide-gray-100 text-sm/6 w-full px-3">                    
                <div class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Tgl. dibuat</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">
                            {{ useFormatTime(manufacture.created_at) || '-' }}
                        </div>
                    </dd>
                </div>

                <div v-if="manufacture.cs_stock" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Sumber</dt>
                    <dd class="flex flex-col items-end gap-y-1">
                        <Tag label="Produksi stok (tanpa pesanan)" :theme="4" noHoverColor />
                        <Link v-if="canOpenKasirPages" :href="route('kasir.stocks.show', manufacture.cs_stock.id)" class="primaryLink text-right font-medium">
                            {{ manufacture.cs_stock.product_name }}
                        </Link>
                        <span v-else class="text-right font-medium">{{ manufacture.cs_stock.product_name }}</span>
                        <span class="text-xs text-gray-400">
                            {{ manufacture.cs_stock.is_general ? 'Stok umum (semua brand)' : `Stok brand ${manufacture.cs_stock.brand_name}` }}
                        </span>
                    </dd>
                </div>

                <div v-else-if="isFromKasir" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Sumber</dt>
                    <dd class="flex items-start gap-x-2">
                        <Tag label="Pesanan Sales Spesial" :theme="8" noHoverColor />
                        <Tag v-if="manufacture.cs_order?.state_label" :label="manufacture.cs_order.state_label" :theme="17" noHoverColor />
                    </dd>
                </div>

                <div v-if="manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Nama Sales</dt>
                    <dd class="flex items-start gap-x-2">
                        <Link v-if="generateLinkSales(manufacture.sales?.username)" :href="generateLinkSales(manufacture.sales?.username)" class="secondaryLink font-medium">
                            {{ manufacture.sales?.name || '-' }}
                        </Link>
                        <span v-else>{{ manufacture.sales?.name || '-' }}</span>
                    </dd>
                </div>

                <div v-if="isFromKasir && !manufacture.cs_stock" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Order</dt>
                    <dd class="flex items-start gap-x-2">
                        <Link v-if="generateLinkKasirOrder(manufacture.cs_order?.slug)" :href="generateLinkKasirOrder(manufacture.cs_order?.slug)" class="primaryLink font-medium">
                            {{ manufacture.cs_order?.reference || '-' }}
                        </Link>
                        <span v-else class="font-medium">{{ manufacture.cs_order?.reference || '-' }}</span>
                    </dd>
                </div>

                <div v-else-if="!isFromKasir && manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Order</dt>
                    <dd class="flex items-start gap-x-2">
                        <Link v-if="generateLinkOrder(manufacture?.order)" :href="generateLinkOrder(manufacture?.order)" class="primaryLink font-medium">
                            {{ manufacture.order?.reference || '-' }}
                        </Link>
                        <span v-else>{{ manufacture.order?.reference || '-' }}</span>
                    </dd>
                </div>

                <div v-if="isFromKasir && !manufacture.cs_stock" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Pelanggan</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ manufacture.cs_order?.customer || '-' }}</div>
                    </dd>
                </div>

                <div v-if="isFromKasir && manufacture.cs_order?.estimated_finished_at" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Estimasi selesai</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ useFormatTime(manufacture.cs_order.estimated_finished_at, { formatTime: 'dd MMM yyyy' }) }}</div>
                    </dd>
                </div>

                <div class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. order</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ locale.number(manufacture.quantity || 0) }} pcs</div>
                    </dd>
                </div>

                <!-- Product -->
                <div class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Nama Produk</dt>
                    <dd class="font-medium text-right">
                        <template v-if="isFromKasir">
                            <Icon v-if="manufacture.cs_order_product?.print_type_icon" :data="manufacture.cs_order_product?.print_type_icon" />
                            <span>{{ manufacture.product_name || manufacture.cs_order_product?.name || '-' }}</span>
                            <div v-if="manufacture.cs_order_product?.variation_name" class="text-xs font-normal text-gray-400">
                                Variasi: {{ manufacture.cs_order_product.variation_name }}
                            </div>
                            <div v-if="manufacture.cs_order_product?.name && manufacture.cs_order_product.name !== manufacture.product_name" class="text-xs font-normal text-gray-400">
                                Nama di invoice: {{ manufacture.cs_order_product.name }}
                            </div>
                        </template>
                        <template v-else-if="manufacture.product">
                            <Icon v-if="manufacture.product?.type_icon" :data="manufacture.product?.type_icon" />
                            <Link v-if="generateLinkProduct(manufacture.product?.slug)" :href="generateLinkProduct(manufacture.product?.slug)" class="secondaryLink font-medium">
                                {{ manufacture.product?.name || '-' }}
                            </Link>
                            <span v-else>{{ manufacture.product?.name || '-' }}</span>
                        </template>
                        <span v-else class="text-gray-400 italic">
                            Produk tidak ditemukan
                            <FontAwesomeIcon v-tooltip="'Produk mungkin telah dihapus'" icon='fal fa-info-circle' class='text-gray-400' fixed-width aria-hidden='true' />
                        </span>
                    </dd>
                </div>

                <!-- Field: Keterangan Order -->
                <div class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Keterangan Order</dt>
                    <dd class="font-medium text-right">
                        <span v-if="isFromKasir && manufacture.cs_order_product?.note">{{ manufacture.cs_order_product.note }}</span>
                        <span v-else-if="!isFromKasir && manufacture.order?.keterangan_cetak">{{ manufacture.order.keterangan_cetak }}</span>
                        <span v-else class="text-gray-400 italic">Tidak ada keterangan order dari Sales</span>
                    </dd>
                </div>

                <div v-if="isFromKasir && manufacture.cs_order_product?.print_type_label" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jenis cetak</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ manufacture.cs_order_product.print_type_label }}</div>
                    </dd>
                </div>

                <div v-if="isFromKasir" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Kategori</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ manufacture.cs_order_product?.category_name || '-' }}</div>
                    </dd>
                </div>

                <div v-else-if="manufacture.product?.category?.name" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Kategori</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ manufacture.product?.category?.name || '-' }}</div>
                    </dd>
                </div>

                <div v-if="manufacture.design_type && !isFromKasir" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Tipe desain</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">
                            {{ manufacture.design_type }}
                        </div>
                    </dd>
                </div>

                <div v-if="manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Brand</dt>
                    <dd class="flex items-start gap-x-2">
                        <Link v-if="generateLinkBrand(manufacture.brand_data?.slug)" :href="generateLinkBrand(manufacture.brand_data?.slug)" class="secondaryLink font-medium">
                            {{ manufacture.brand || '-' }}
                        </Link>
                        <span v-else>{{ manufacture.brand || '-' }}</span>
                    </dd>
                </div>

                <div v-if="isFromKasir ? manufacture.cs_order?.note : manufacture.order?.note" class="flex flex-col justify-between gap-x-4 gap-y-1 py-3">
                    <dt class="text-gray-500">Catatan (dari sales)</dt>
                    <dd class="italic px-3 py-1 rounded-md flex items-start gap-x-2 bg-gray-50 border border-gray-300 text-gray-600">
                        {{ isFromKasir ? manufacture.cs_order?.note : manufacture.order?.note }}
                    </dd>
                </div>

            </dl>
        </Fieldset>

        <!-- Box: Manufacture -->
        <Fieldset legend="Manufacture" class="h-fit w-full lg:max-w-lg">
            <dl class="divide-y divide-gray-100 text-sm/6 w-full px-3">
                <div v-if="manufacture.pra_cetak_at" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. plat (CMYK)</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ locale.number(manufacture.pra_cetak_count_plat || 0) }} plat</div>
                    </dd>
                </div>

                <div v-if="manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. tercetak</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ locale.number(manufacture.cetak_count || 0) }} pcs</div>
                    </dd>
                </div>

                <div v-if="manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. finishing</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ locale.number(manufacture.finishing_count || 0) }} pcs</div>
                    </dd>
                </div>

                <div v-if="manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. plastik</dt>
                    <dd class="flex items-start gap-x-2">
                        <div class="font-medium">{{ locale.number(manufacture.plastic_count || 0) }} pcs <span class="text-gray-400">(@{{ locale.number(manufacture.piece_per_plastic_count || 0) }}pcs)</span></div>
                    </dd>
                </div>

                <div v-if="manufacture.product?.type !== 'polos'" class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. kerusakan di Finishing</dt>
                    <dd class="flex items-start gap-x-2" :class="(manufacture.finishing_broken_count || 0) > 0 ? 'text-red-500' : ''">
                        <div class="font-medium">{{ locale.number(manufacture.finishing_broken_count || 0) }} pcs</div>
                    </dd>
                </div>
                
                <div class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. validasi</dt>
                    <dd class="flex items-start gap-x-2">
                        <div v-if="typeof manufacture.validated_count === 'number'" class="font-medium">
                            {{ locale.number(manufacture.validated_count || 0) }} pcs
                            <FontAwesomeIcon v-if="manufacture.validated_at" v-tooltip="'Tervalidasi'" icon='fal fa-check' class='text-green-600' fixed-width aria-hidden='true' />
                        </div>
                        <div v-else class="font-medium">-</div>
                    </dd>
                </div>
                
                <div class="flex justify-between gap-x-4 py-3">
                    <dt class="text-gray-500">Jml. validasi dari customer</dt>
                    <dd class="flex items-start gap-x-2">
                        <div v-if="typeof manufacture.count_validate_from_customer === 'number'" class="font-medium">
                            {{ locale.number(manufacture.count_validate_from_customer || 0) }} pcs
                            <FontAwesomeIcon v-if="manufacture.count_validate_from_customer_setted_at" v-tooltip="'Tervalidasi'" icon='fal fa-check' class='text-orange-500' fixed-width aria-hidden='true' />
                        </div>
                        <div v-else class="font-medium">-</div>
                    </dd>
                </div>
                
                <div class="flex flex-col justify-between gap-x-4 gap-y-1 py-3">
                    <dt class="text-gray-500">Catatan pra-cetak</dt>
                    <dd class="italic px-3 py-1 rounded-md flex items-start gap-x-2 bg-gray-50 border border-gray-300 text-gray-600">
                        {{ manufacture.pra_cetak_note ?? '-' }}
                    </dd>
                </div>
            </dl>
        </Fieldset>

        

        <!-- Box: Desain (khusus pesanan Sales Spesial) -->
        <Fieldset v-if="isFromKasir" legend="Desain" class="lgx:col-span-2 w-full h-fit">
            <div v-if="manufacture.design_type" class="flex justify-between gap-x-4 border-b border-gray-100 px-3 py-3 text-sm/6">
                <span class="text-gray-500">Tipe desain</span>
                <span class="font-medium">{{ manufacture.design_type }}</span>
            </div>
            <ul v-if="manufacture.designs?.length" class="divide-y divide-gray-100 text-sm/6 w-full px-3">
                <li v-for="design in manufacture.designs" :key="design.id" class="flex items-start justify-between gap-x-4 py-3">
                    <div class="min-w-0">
                        <div class="flex items-center gap-x-2">
                            <div class="font-medium">{{ design.name }}</div>
                            <Tag v-if="design.is_for_this_product" label="Produk ini" :theme="3" noHoverColor />
                        </div>
                        <div class="text-xs text-gray-400">{{ design.product_name || 'Semua produk' }}</div>
                        <div v-if="design.link_updated_at" class="text-xs text-gray-400">
                            Diupdate {{ useFormatTime(design.link_updated_at) }}
                        </div>
                        <div v-if="design.note" class="mt-1 italic px-3 py-1 rounded-md bg-gray-50 border border-gray-300 text-gray-600 text-xs">
                            {{ design.note }}
                        </div>
                    </div>
                    <a :href="design.link" target="_blank" rel="noopener" class="primaryLink shrink-0 whitespace-nowrap font-medium">
                        Buka desain
                        <FontAwesomeIcon icon="fal fa-external-link" fixed-width aria-hidden="true" />
                    </a>
                </li>
            </ul>
            <div v-else class="px-3 py-3 text-sm text-gray-400 italic">
                Belum ada desain yang dilampirkan Sales Spesial ke pesanan ini.
            </div>
        </Fieldset>

    </div>

    

    <!-- Box -->
    <!-- <BoxStatsPalletDelivery :dataPalletDelivery="data.data" :boxStats="box_stats" :updateRoute /> -->

    <!-- <Tabs :current="currentTab" :navigation="tabs['navigation']" @update:tab="handleTabUpdate" /> -->

    <!-- Modal: Pra Cetak -->
    <Dialog
        :visible="selectedModal === 'pra_cetak'" 
        :dismissableMask="true"
        :closable="true"
        modal
        header="Selesaikan pra-cetak"
        :style="{ width: '30rem' }"
        @update:visible="(e: boolean) => selectedModal = null"
    >
        <!-- <div class="flex items-center gap-4 mb-8">
            <Select v-model="countPlat" :options="[1, 2, 3, 4]" placeholder="Jumlah plat" class="w-full" />
        </div> -->

        <div class="flex flex-col gap-2 mb-12">
            <div>
                Masukkan jumlah plat (CMYK):
            </div>
            <div class="grid grid-cols-2 gap-4">
                <div v-for="number in 4" @click="() => countPlat = number" class="px-3 py-4 border cursor-pointer w-full text-center rounded"
                    :class="countPlat === number ? 'bg-blue-600 text-white' : 'bg-blue-50 border-dashed border-gray-300'"
                >
                    {{ number }} plat
                </div>
            </div>
        </div>

        <div class="flex flex-col gap-2 mb-8">
            <div>
                Catatan pra-cetak (opsional):
            </div>
            <PureTextarea v-model.trim="praCetakNote" placeholder="Masukkan catatan jika ada" class="w-full" :rows="4" />
        </div>

        <div class="flex justify-end gap-2">
            <Button label="Cancel" :style="'tertiary'" @click="selectedModal = null"></Button>
            <Button label="Save" @click="submitSelesaikan" :loading="isLoading" full></Button>
        </div>
    </Dialog>

    <!-- Modal: Cetak -->
    <Dialog
        :visible="selectedModal === 'cetak'" 
        :dismissableMask="true"
        :closable="true"
        modal
        header="Masukkan keterangan cetak"
        :style="{ width: '30rem' }"
        @update:visible="(e: boolean) => selectedModal = null"
    >
        <div class="flex flex-col justify-center gap-1 mb-6">
            <label for="input-cetak" class="font-semibold block">Jumlah tercetak</label>
            <!-- <InputNumber v-model="cetak_count" @update:modelValue="() => delete errors.cetak_count" inputId="input-cetak" :placeholder="`${manufacture.quantity} pcs`" locale="id-ID" suffix=" pcs" fluid :invalid="!!errors.cetak_count"/> -->
            <input
                v-model="cetak_count"
                @change="() => delete errors.cetak_count"
                type="tel"
                pattern="[0-9]*"
                inputmode="numeric"
                name="input-cetak"
                id="input-cetak"
                class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                placeholder="999 pcs"
                aria-describedby="input-cetak"
            />
            <p v-if="errors.cetak_count" class="text-red-500">{{ errors.cetak_count }}</p>
        </div>

        <div class="flex flex-col gap-1 mb-6">
            <label for="username" class="font-semibold">Catatan cetak</label>
            <Textarea v-model="cetak_note" rows="5" fluid placeholder="Masukkan catatan cetak" class="mb-8" />
        </div>

        <div class="flex justify-end gap-2">
            <Button label="Cancel" :style="'tertiary'" @click="selectedModal = null"></Button>
            <Button label="Save" @click="submitSelesaikan" :loading="isLoading" full></Button>
        </div>
    </Dialog>

    <!-- Modal: Finishing -->
    <Dialog
        :visible="selectedModal === 'finishing'" 
        :dismissableMask="true"
        :closable="true"
        modal
        header="Masukkan keterangan finishing"
        :style="{ width: '30rem' }"
        @update:visible="(e: boolean) => selectedModal = null"
    >
        <div class="grid grid-cols-2 gap-x-4">
            <div class="flex flex-col justify-center gap-1 mb-6">
                <label for="plastic_count" class="font-semibold block">Jumlah plastik</label>
                <!-- <InputNumber v-model="countPlastic" inputId="plastic_count" placeholder="999 pcs" locale="id-ID" suffix=" pcs" fluid /> -->
                <input
                    v-model="countPlastic"
                    @change="() => delete errors.plastic_count"
                    type="tel"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    name="plastic_count"
                    id="plastic_count"
                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                    placeholder="999 pcs"
                    aria-describedby="plastic_count"
                />
                <p v-if="errors.plastic_count" class="text-red-500">{{ errors.plastic_count }}</p>
            </div>
            <div class="flex flex-col justify-center gap-1 mb-6">
                <label for="perplastic" class="font-semibold block">Jumlah isi perplastik</label>
                <!-- <InputNumber v-model="countPiecePerPlastic" inputId="perplastic" placeholder="999 pcs" locale="id-ID" suffix=" pcs" fluid /> -->
                <input
                    v-model="countPiecePerPlastic"
                    @change="() => delete errors.piece_per_plastic_count"
                    type="tel"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    name="perplastic"
                    id="perplastic"
                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                    placeholder="999 pcs"
                    aria-describedby="perplastic"
                />
                <p v-if="errors.piece_per_plastic_count" class="text-red-500">{{ errors.piece_per_plastic_count }}</p>
            </div>
        </div>

        <div class="grid grid-cols-2 items-start gap-x-4">
            <div class="flex flex-col justify-center gap-1 mb-6">
                <label for="finish_count" class="font-semibold block">Jumlah jadi</label>
                <!-- <InputNumber v-model="finishing_count" inputId="finish_count" placeholder="999 pcs" locale="id-ID" suffix=" pcs" fluid /> -->
                <input
                    v-model="finishing_count"
                    @change="() => delete errors.finishing_count"
                    type="tel"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    name="finish_count"
                    id="finish_count"
                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                    placeholder="999 pcs"
                    aria-describedby="finish_count"
                />
                <div
                    @click="() => finishing_count = manufacture.cetak_count"
                    class="text-sm select-none w-fit"
                    :class="finishing_count === manufacture.cetak_count ? 'text-gray-300' : 'underline cursor-pointer text-gray-400 hover:text-gray-600'"
                >
                    Sesuai cetak ({{ manufacture.cetak_count }} pcs)
                </div>
                <p v-if="errors.finishing_count" class="text-red-500">{{ errors.finishing_count }}</p>
            </div>
            <div class="flex flex-col justify-center gap-1 mb-6">
                <label for="broken_count" class="font-semibold block">Jumlah rusak</label>
                <!-- <InputNumber v-model="finishing_broken_count" inputId="broken_count" placeholder="999 pcs" locale="id-ID" suffix=" pcs" fluid /> -->
                <input
                    v-model="finishing_broken_count"
                    @change="() => delete errors.finishing_broken_count"
                    type="tel"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    name="broken_count"
                    id="broken_count"
                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                    placeholder="999 pcs"
                    aria-describedby="broken_count"
                />
                <p v-if="errors.finishing_broken_count" class="text-red-500">{{ errors.finishing_broken_count }}</p>
            </div>
        </div>

        <div class="flex flex-col gap-1 mb-6">
            <label for="username" class="font-semibold">Catatan finishing</label>
            <Textarea v-model="finishing_note" rows="5" fluid placeholder="Masukkan catatan finishing" class="mb-8" />
        </div>

        <div class="flex justify-end gap-2">
            <Button label="Cancel" :style="'tertiary'" @click="selectedModal = null"></Button>
            <Button label="Save" @click="submitSelesaikan" :loading="isLoading" full></Button>
        </div>
    </Dialog>

    <!-- Modal: Validate -->
    <Dialog
        :visible="selectedModal === 'validate'" 
        :dismissableMask="true"
        :closable="true"
        modal
        header="Validasi Manufaktur"
        :style="{ width: '30rem' }"
        @update:visible="(e: boolean) => selectedModal = null"
    >
        <div class="flex flex-col gap-2 mb-8">
            <label for="validated-count" class="font-semibold">Jumlah quantity</label>
            <!-- <InputNumber v-model="validated_count" inputId="integeronly" :placeholder="`${manufacture.finishing_count} pcs`" suffix=" pcs" fluid /> -->
            <input
                v-model="validated_count"
                @change="() => delete errors.validated_count"
                type="tel"
                pattern="[0-9]*"
                inputmode="numeric"
                name="validated-count"
                id="validated-count"
                class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                placeholder="999 pcs"
                aria-describedby="validated-count"
            />
            <div
                v-if="manufacture.product?.type === 'polos'"
                @click="() => validated_count = manufacture.quantity"
                class="text-sm select-none w-fit"
                :class="validated_count === manufacture.quantity ? 'text-gray-300' : 'underline cursor-pointer text-gray-400 hover:text-gray-600'"
            >
                Sesuai order ({{ manufacture.quantity }} pcs)
            </div>
            <div
                v-else
                @click="() => validated_count = manufacture.finishing_count"
                class="text-sm select-none w-fit"
                :class="validated_count === manufacture.finishing_count ? 'text-gray-300' : 'underline cursor-pointer text-gray-400 hover:text-gray-600'"
            >
                Sesuai finishing ({{ manufacture.finishing_count }} pcs)
            </div>
            <p v-if="errors.validated_count" class="text-red-500">{{ errors.validated_count }}</p>
        </div>

        <div class="flex flex-col gap-2 mb-3">
            <label for="username" class="font-semibold">Catatan validasi</label>
            <Textarea v-model="validate_note" rows="5" fluid placeholder="Masukkan catatan tambahan" class="mb-8" />
        </div>

        <div class="flex justify-end gap-2">
            <Button label="Cancel" :style="'tertiary'" @click="selectedModal = null"></Button>
            <Button label="Save" @click="submitSelesaikan" :loading="isLoading" full></Button>
        </div>
    </Dialog>

    <!-- Modal: Validate Customer -->
    <Dialog
        :visible="selectedModal === 'validate_customer'" 
        :dismissableMask="true"
        :closable="true"
        modal
        header="Validasi oleh customer"
        :style="{ width: '30rem' }"
        @update:visible="(e: boolean) => selectedModal = null"
    >
        <div class="flex flex-col gap-2 mb-8">
            <label for="validated-customer" class="font-semibold">Jumlah quantity</label>
            <!-- <InputNumber v-model="validated_count" inputId="integeronly" :placeholder="`${manufacture.finishing_count} pcs`" suffix=" pcs" fluid /> -->
            <input
                v-model="count_validate_from_customer"
                @change="() => delete errors.count_validate_from_customer"
                type="tel"
                pattern="[0-9]*"
                inputmode="numeric"
                name="validated-customer"
                id="validated-customer"
                class="block w-full rounded-md bg-white px-3 py-1.5 text-base placeholder:text-gray-400 focus:ring-sky-300 sm:text-sm/6"
                placeholder="999 pcs"
                aria-describedby="validated-customer"
            />
            <div
                v-if="manufacture.product?.type === 'polos'"
                @click="() => count_validate_from_customer = manufacture.quantity"
                class="text-sm select-none w-fit"
                :class="count_validate_from_customer === manufacture.quantity ? 'text-gray-300' : 'underline cursor-pointer text-gray-400 hover:text-gray-600'"
            >
                Sesuai order ({{ manufacture.quantity }} pcs)
            </div>
            <div v-else class="flex justify-between">
                <div
                    @click="() => count_validate_from_customer = manufacture.finishing_count"
                    class="text-sm select-none w-fit"
                    :class="count_validate_from_customer === manufacture.finishing_count ? 'text-gray-300' : 'underline cursor-pointer text-gray-400 hover:text-gray-600'"
                >
                    Sesuai finishing ({{ manufacture.finishing_count }} pcs)
                </div>

                <div
                    v-if="manufacture.validated_count"
                    @click="() => count_validate_from_customer = manufacture.validated_count"
                    class="text-sm select-none w-fit"
                    :class="count_validate_from_customer === manufacture.validated_count ? 'text-gray-300' : 'underline cursor-pointer text-gray-400 hover:text-gray-600'"
                >
                    Sesuai validasi pertama ({{ manufacture.validated_count }} pcs)
                </div>
            </div>
            <p v-if="errors.count_validate_from_customer" class="text-red-500">{{ errors.count_validate_from_customer }}</p>
        </div>

        <div class="flex flex-col gap-2 mb-3">
            <label for="username" class="font-semibold">Catatan validasi kedua</label>
            <Textarea v-model="count_validate_from_customer_note" rows="5" fluid placeholder="Masukkan catatan tambahan" class="mb-8" />
        </div>

        <div class="flex justify-end gap-2">
            <Button label="Cancel" :style="'tertiary'" @click="selectedModal = null"></Button>
            <Button label="Save" @click="submitValidateCustomer" :loading="isLoadingValidateCustomer" full></Button>
        </div>
    </Dialog>
</template>

<style lang="css" scoped>
.p-steplist {
    overflow-x: visible;
}
</style>